import PropTypes from "prop-types";

export let MediaPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number,
    mediaType: PropTypes.number,
    commentId: PropTypes.number,
    filename: PropTypes.string,
    starred: PropTypes.bool,
    url: PropTypes.string,
  })
);

export let CommentPropType = PropTypes.shape({
  id: PropTypes.number,
  itemId: PropTypes.number,
  created: PropTypes.string,
  lastEdited: PropTypes.string,
  media: MediaPropType,
  parentId: PropTypes.number,
  text: PropTypes.string,
  userId: PropTypes.string,
});

export let ImplementationPropType = PropTypes.shape({
  allowAudio: PropTypes.bool,
  allowImages: PropTypes.bool,
  allowVidep: PropTypes.bool,
  apiPath: PropTypes.string,
  archived: PropTypes.bool,
  characterLimit: PropTypes.number,
  commentMessage: PropTypes.string,
  id: PropTypes.string,
  isCommentMandatory: PropTypes.bool,
  isMedisMandatory: PropTypes.bool,
  moderationEmailMessage: PropTypes.string,
  moderationTimeInMinutes: PropTypes.number,
  name: PropTypes.string,
  restrictScopeToModerator: PropTypes.bool,
  thanksEmailMessage: PropTypes.string,
  thanksMessage: PropTypes.string,
  useMapView: PropTypes.bool,
});

export let LocationProptype = PropTypes.shape({
  id: PropTypes.string,
  itemId: PropTypes.number,
  address: PropTypes.string,
  easting: PropTypes.string,
  northing: PropTypes.string
});

export let ItemPropType = PropTypes.shape({
  id: PropTypes.number,
  implementationId: PropTypes.string,
  implementation: ImplementationPropType,
  path: PropTypes.string,
  category: PropTypes.string,
  comments: PropTypes.arrayOf(CommentPropType),
  pendingComments: PropTypes.arrayOf(CommentPropType),
  externalId: PropTypes.string,
  location: LocationProptype,
  name: PropTypes.string
});
